var _path, _g, _path2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHappyHomeCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_344_26",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 171,
    width: 901,
    height: 655
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 171H951.823V825.667H51V171Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_344_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.6613 180.989C56.1717 188.896 58.7551 197 63.3749 204.245C67.9947 211.495 72.1144 218.828 76.9582 225.802C87.1249 240.635 101.031 255.239 114.005 267.557C140.364 292.604 168.281 315.948 196.135 339.317C252.745 386.573 311.073 431.677 369.948 475.948C485.385 562.719 604.323 644.557 726.766 721.474C760.547 742.698 794.573 763.521 828.844 783.948C847.114 794.838 865.073 803.76 883.573 812.932C903.588 822.849 923.739 829.802 945.14 819.724C946.125 819.172 947.015 818.505 947.818 817.708C948.614 816.916 949.297 816.031 949.859 815.057C950.417 814.078 950.838 813.047 951.114 811.953C951.396 810.864 951.526 809.755 951.5 808.63C949.51 788.974 937.734 774.776 921.838 763.791C906.849 753.448 892.854 743.166 877.187 733.88C845.802 715.344 814.62 696.474 783.646 677.271C722.87 639.531 662.896 600.578 603.719 560.406C485.562 480.114 372.37 394.75 261.234 306.213C228.943 280.51 197.422 253.698 164.635 228.656C148.469 216.25 131.708 204.692 114.37 193.989C97.453 183.573 78.6561 177.411 59.8644 171.64C54.0467 169.849 50.5572 176.166 52.6613 180.989Z",
    fill: "#F4ADCE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_344_26",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 140,
    width: 876,
    height: 716
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 140H940V855.599H64V140Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_344_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M928.557 141.011C910.896 143.615 896.427 152.693 881.255 161.391C865.135 170.698 848.401 178.984 833.479 190.172C803.651 212.495 774.146 235.214 744.963 258.328C687.63 303.615 631.156 349.854 574.391 395.797C462.26 486.505 348.406 575.88 239.104 670.146C177.969 723.281 120.448 780.084 66.5416 840.542C60.0624 847.766 68.2603 859.469 77.1614 854.287C109.198 835.672 141.719 816.854 172.125 795.75C201.562 775.37 231.885 756.078 260.234 734.318C318.562 689.573 375.713 643.38 432.708 597.005C544.771 505.912 657.38 415.36 768.333 323.021C799.49 297.068 830.51 270.938 860.901 244.13C876.531 230.063 891.088 214.969 904.578 198.844C917.693 183.537 931.505 170.266 938.547 150.906C940.812 144.453 934.016 140.151 928.583 140.943L928.557 141.011Z",
    fill: "#F4ADCE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyHomeCrossIcon);
export default __webpack_public_path__ + "static/media/HappyHome_CrossIcon.5b0b764f98ece7e7ce8adcb420e2c295.svg";
export { ForwardRef as ReactComponent };